
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PaymentTypeGrid extends Serenity.EntityGrid<PaymentTypeRow, any> {
        protected getColumnsKey() { return PaymentTypeColumns.columnsKey; }
        protected getDialogType() { return PaymentTypeDialog; }
        protected getIdProperty() { return PaymentTypeRow.idProperty; }
        protected getInsertPermission() { return PaymentTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return PaymentTypeRow.localTextPrefix; }
        protected getService() { return PaymentTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}